export const environment = {
  production: true,
  firebase: {
    projectId: 'anyo-2022',
    appId: '1:496659584103:web:cc8f9293d7de79ef19f0c2',
    storageBucket: 'anyo-2022.appspot.com',
    apiKey: 'AIzaSyApoVuNGIhdUfkm9RLhGil28_IDO49t25Q',
    authDomain: 'anyo-2022.firebaseapp.com',
    messagingSenderId: '496659584103',
    measurementId: 'G-NNQLJW56KX',
  },
  contentServiceUrl: 'https://alpha-files-api.anyo.app',
  apiBackendBaseUrl: 'https://apiv3.anyo.app',
  serviceUrl: 'https://apiv1.portal.anyo.app/',
  serviceUrl2: 'https://apiv1.auth.anyo.app/',
  domain: 'anyo.app',
  app: 'listener-portal',
};
